/**
 * UnderwritingStatusBadge - the Tab-5b Underwriting status chip (P2 Slice 14). One Badge tone per
 * underwriting-relevant Antrag status; null = «Noch nicht eingereicht».
 */

import { Badge } from '../../components/ui/Badge';
import type { BadgeVariant } from '../../components/ui/Badge';
import type { ApplicationStatus } from '@brokly/shared';

const UW_TONE: Partial<Record<ApplicationStatus, { variant: BadgeVariant; label: string }>> = {
  eingereicht: { variant: 'info', label: 'Eingereicht' },
  bedingungen_geaendert: { variant: 'warning', label: 'Bedingungen geaendert' },
  angenommen: { variant: 'success', label: 'Angenommen' },
  abgelehnt: { variant: 'danger', label: 'Abgelehnt' },
  deckungsbestaetigt: { variant: 'success', label: 'Deckungsbestaetigt' },
  police_erhalten: { variant: 'success', label: 'Police erhalten' },
};

export function UnderwritingStatusBadge({ status }: { status: ApplicationStatus | null }) {
  const tone = status ? UW_TONE[status] : undefined;
  if (!tone) {
    return (
      <Badge variant="neutral" data-testid="uw-status-badge">
        Noch nicht eingereicht
      </Badge>
    );
  }
  return (
    <Badge variant={tone.variant} data-testid="uw-status-badge">
      {tone.label}
    </Badge>
  );
}
